var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgElectronicTwostep = function SvgElectronicTwostep(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#A266A2",
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M10 2 9 7h3l-6 7 1-5H4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.975 5.417v.608H1.568q-.006-.228.074-.44.13-.347.417-.685c.287-.338.467-.485.828-.78q.84-.69 1.135-1.092c.295-.402.296-.522.296-.761q0-.376-.27-.635c-.27-.259-.412-.258-.7-.258q-.458 0-.732.274c-.274.274-.275.436-.278.76l-.65-.067q.066-.727.503-1.11c.437-.382.68-.38 1.17-.38q.742 0 1.174.41c.432.41.433.615.433 1.02q0 .31-.127.608c-.127.298-.224.409-.42.63s-.52.522-.976.906q-.57.479-.73.649c-.16.17-.198.228-.268.343z"
  })));
};
export default SvgElectronicTwostep;